import React from 'react';
import FormLoginDesign from './form_login.js';
import FormForgetDesign from './form_forget.js';
import FormCode from './form_code.js';
import FormContact from './form_contact.js';
import FormReset from './form_reset.js';
import FormContactType from './form_contact_type.js';
import {connect} from 'react-redux';
import SocialMedia from './socialMedia'
import '../auth.css'
function checkPage(data)
{
  if(data === "SIGN IN")
  {
return(

  <div className="ui card">
  <img src={require('../pictures/new_login.png')} className="ui image image_text" />
  <div className="contents" >
  <FormLoginDesign></FormLoginDesign>
  </div>
  <SocialMedia/>
  </div>

);}

else if(data === "FORGET PASSWORD")
{
return(
  <div className="ui card forget_card">
  <img src={require('../pictures/new_login.png')} className="ui image image_text" />
  <div className="contentsForget">
  <FormForgetDesign></FormForgetDesign>
  </div>
  </div>
);}


else if(data === "RESET PASSWORD")
{
return(
  <div className="ui card forget_card">
  <img src={require('../pictures/new_login.png')} className="ui image image_text" />
  <div className="contents">
  <FormReset></FormReset>
  </div>
  </div>
);}


else if(data === "ENTER PASSWORD")
{
return(
  <div className="ui card forget_card">
  <img src={require('../pictures/new_login.png')} className="ui image image_text" />
  <div className="contents">
  <FormCode></FormCode>
  </div>
  </div>
);}
else if(data === "CONTACT US")
{
return(
  <div className="ui card forget_card">
  <img src={require('../pictures/new_login.png')} className="ui image image_text" />
  <div className="contents">
  <FormContact></FormContact>
  </div>
  </div>
);}
else if(data === "CONTACT US Type")
{
return(
  <div className="ui card forget_card">
  <img src={require('../pictures/new_login.png')} className="ui image image_text" />
  <div className="contents">
  <FormContactType></FormContactType>
  </div>
  </div>
);}
}

const ModalModal = (props) => (

  <div>
  {checkPage(props.text_img)}
  </div>

)

const mapStateToProps = (state)=>{
  return {...state}
}

export default connect(mapStateToProps)(ModalModal);
